import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=8802d8d4&"
import script from "./CampaignSummary.vue?vue&type=script&lang=js&"
export * from "./CampaignSummary.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports